import React from 'react';
import { KuposInput } from '../../../../common';
import getIcons from '../../../functions/getIcons/getIcons';

function Steps(props) {
  return (
    <div className="recharge-steps-outer">
      <div className="inputs">
        <div className="title bold-text font10">{props.t('PROFILE.RECHARGE_AMOUNT')}</div>
        <KuposInput
          placeholder="$XXXXX"
          className="kupos-border font10"
          value={props.rechargeAmount}
          onBlur={() => {}}
          onChange={val => props.onRechargeAmountChange(val)}
          error={props.amountError ? true : false}
          errorMessage={props.amountError ? props.amountError.message : ''}
        />
        <div className="button-container font12">
          <button
            className="kupos-button"
            disabled={props.data.walletRechargePending}
            onClick={props.rechargeRequest}
            style={{
              backgroundColor:
                props.operator &&
                props.operator.color_codes &&
                props.operator.color_codes.button_color
                  ? props.operator.color_codes.button_color
                  : '',
            }}
          >
            {props.data.walletRechargePending ? (
              <div className="loader-cricle"></div>
            ) : (
              <span>{props.t('HOME.RECHARGE')}</span>
            )}
          </button>
        </div>
      </div>
      <div className="steps">
        <div className="title bold-text font10">{props.t('PROFILE.HOW_TO_RECHARGE')}</div>

        <div className="wallet-recharge-extra-items">
          <div>
            <div className="kupos-card" style={{ height: 145 }}>
              <div className="wallet-recharge-extra-item">
                <span className="bold-text font10">{props.t('PROFILE.STEP')} 1</span>
                <img src={getIcons('paso_1', props.operator)} alt="" />
              </div>
              <span className="font8">{props.t('PROFILE.ENTER_RECHARGE_AMOUNT')}</span>
            </div>

            <div className="kupos-card">
              <div className="wallet-recharge-extra-item">
                <span className="bold-text font10">{props.t('PROFILE.STEP')} 3</span>
                <img src={getIcons('paso_3', props.operator)} alt="" />
              </div>
              <span className="font8">{props.t('PROFILE.SHARE_RUT_AGENT')} </span>
            </div>
          </div>
          <div>
            <div className="kupos-card" style={{ height: 145 }}>
              <div className="wallet-recharge-extra-item">
                <span className="bold-text font10">{props.t('PROFILE.STEP')} 2</span>
                <img src={getIcons('paso_2', props.operator)} alt="" />
              </div>
              <span className="font8">{props.t('PROFILE.FIND_REC_POINT')}</span>
              <span
                onClick={props.showMap}
                className="font8 "
                style={{
                  marginTop: -5,
                  cursor: 'pointer',
                  color:
                    props.operator &&
                    props.operator.color_codes &&
                    props.operator.color_codes.account_text_color,
                }}
              >
                {props.t('PROFILE.REC_POINT_LINK')}
              </span>
            </div>

            <div className="kupos-card">
              <div className="wallet-recharge-extra-item">
                <span className="bold-text font10">{props.t('PROFILE.STEP')} 4</span>
                <img src={getIcons('paso_4', props.operator)} alt="" />
              </div>
              <span className="font8">{props.t('PROFILE.FIVE_MIN_MONEY')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Steps;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/RechargeWalletKupospayRecharge/components/Steps.js